import { useRoutes } from 'react-router-dom';
//================import home pages=================
import Home from 'pages/home';
//================import about Pages=================
import AboutUs from 'pages/about-us';
import OurClient from 'pages/about-us/OurClient';
import OurTeam from 'pages/about-us/OurTeam';
import SuccessStories from 'pages/about-us/SuccessStories';
//================import whatWeDo Pages=================
import WhatWeDo from 'pages/whatWeDo';
import Customize from 'pages/whatWeDo/Customize';
import Corporative from 'pages/whatWeDo/Corporative';
import Private from 'pages/whatWeDo/Private';
import Entertainment from 'pages/whatWeDo/Entertainment';
//================import Service Page=================
import Services from 'pages/services';
//================import Service Page=================
import ContactUs from 'pages/contact-us';
//================import portfolio Pages=================
import OurPortfolio from 'pages/portfolio';
import EventDetail from 'components/portfolio/EventDetail';
import PrivateEvents from 'pages/portfolio/PrivateEvents';
import EntertainmentEvents from 'pages/portfolio/EntertainmentEvents';
import CorporativeEvents from 'pages/portfolio/CorporativeEvents';
//================import 404 Pages=================
import ErrorPage from 'pages/404/404Page';

const useRoutesHook = () => {
  let element = useRoutes([
    { path: '/', element: <Home /> },
    { path: '/about-us', element: <AboutUs /> },
    { path: '/about-us/our-clients', element: <OurClient /> },
    { path: '/about-us/our-team', element: <OurTeam /> },
    { path: '/about-us/success-stories', element: <SuccessStories /> },
    { path: '/what-we-do', element: <WhatWeDo /> },
    { path: '/what-we-do/corporative', element: <Corporative/> },
    { path: '/what-we-do/private', element: <Private/> },
    { path: '/what-we-do/entertainment', element: <Entertainment/> },
    { path: '/what-we-do/customize', element: <Customize /> },
    { path: '/services', element: <Services /> },
    { path: '/contact-us', element: <ContactUs /> },
    { path: '/portfolio', element: <OurPortfolio /> },
    { path: '/portfolio/private', element: <PrivateEvents /> },
    { path: '/portfolio/entertainment', element: <EntertainmentEvents /> },
    { path: '/portfolio/corporative', element: <CorporativeEvents/> },
    { path: '/portfolio/detail', element: <EventDetail /> },
    { path: '/*', element: <ErrorPage /> },
  ]);
  return element;
};

export default useRoutesHook;
